// ดึงยอด credit ล่าสุดแล้วแนบเป็น field "credit" ให้ api-analyst (ใช้เมื่อ isCredit=true)
// ถ้าดึงยอดไม่ได้จะไม่แนบ credit -> api-analyst นับเป็น 0 (prepaid จะ analyze ไม่ผ่าน)
export function appendCreditBalance(client, formData, token) {
    return client.post('api/credit/get_credit_byuser', JSON.stringify({}), {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
        }
    })
        .then(response => {
            const balance = response.data ? response.data.balance : undefined;
            if (balance !== undefined && balance !== null && balance !== '') {
                formData.append("credit", balance);
            } else {
                console.warn("[appendCreditBalance] get_credit_byuser returned no balance, analyze will be sent without credit", response.data);
            }
        })
        .catch(error => {
            console.warn("[appendCreditBalance] get_credit_byuser failed, analyze will be sent without credit", error);
        });
}
